import { render, staticRenderFns } from "./ClinicalTrialPhases.vue?vue&type=template&id=19067a0e&"
import script from "./ClinicalTrialPhases.vue?vue&type=script&lang=js&"
export * from "./ClinicalTrialPhases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports